import dayjs from 'dayjs';
import axiosClient, { serializeAxiosQueryParams } from './axiosClient';

export interface IBc01Params {
  username: string;
  from: string;
  to: string;
  persons?: string[];
}

export interface IBc02Params extends IBc01Params {
  type: string;
}

export interface IBc01Response {
  total?: number;
  page_size?: number;
  page_index?: number;
  report_name?: string;
  headers?: string[];
  headers_mobile?: string[];
  summary_headers?: string[];
  data?: string[][];
  summary_data?: unknown[];
  map_data?: Record<string, unknown>;
  /** Một số endpoint bọc payload giống `personApi` (`IResponseGetPerson`). */
  result?: { headers?: string[]; data?: string[][] };
}

/** Đọc `headers` / `data` từ body phẳng hoặc từ `result`. */
export function parseBc01ResponsePayload(data: unknown): { headers: string[]; data: string[][] } {
  if (!data || typeof data !== 'object') {
    return { headers: [], data: [] };
  }
  const root = data as Record<string, unknown>;
  const inner =
    root.result != null && typeof root.result === 'object' && !Array.isArray(root.result)
      ? (root.result as Record<string, unknown>)
      : root;
  const headers = Array.isArray(inner.headers) ? (inner.headers as string[]) : [];
  const rows = Array.isArray(inner.data) ? (inner.data as string[][]) : [];
  return { headers, data: rows };
}

const API_DATETIME = 'YYYY-MM-DD HH:mm:ss';

function toApiDateTimeString(value: string): string {
  const d = dayjs(value);
  return d.isValid() ? d.format(API_DATETIME) : value;
}

function bc04RequestQuery(params: IBc01Params): Record<string, unknown> {
  const q: Record<string, unknown> = {
    username: params.username,
    from: toApiDateTimeString(params.from),
    to: toApiDateTimeString(params.to),
  };
  if (params.persons != null && params.persons.length > 0) {
    q.persons = params.persons.map(String);
  }
  return q;
}

const reportApi = {
  getBc01(params: IBc01Params, signal?: AbortSignal) {
    return axiosClient.get<IBc01Response>('/api/data/bc01', { params, signal });
  },
  getBc02(params: IBc02Params, signal?: AbortSignal) {
    return axiosClient.get<IBc01Response>('/api/data/bc02', { params, signal });
  },
  getBc04(params: IBc01Params, signal?: AbortSignal) {
    return axiosClient.get<IBc01Response>('/api/data/bc04', {
      params: bc04RequestQuery(params),
      paramsSerializer: serializeAxiosQueryParams,
      signal,
    });
  },
};

export default reportApi;
